import { FieldName, Form, FormType, PromptType, SelectField, SelectFieldValue } from './Form.types';

export const inStyleOfOptions: SelectFieldValue[] = [
  { label: 'a Friend', value: 'a sarcastic comedian' },
  { label: 'a Haiku', value: 'a haiku' },
  { label: 'a Romantic', value: 'a hopeless romantic' },
  { label: 'Shakespeare', value: 'Shakespeare' },
  { label: 'a Therapist', value: 'motivational therapist' },
  { label: 'a Pirate', value: 'a drunken exaggerated pirate' },
  { label: 'a Pessimistic Ex', value: 'an exaggerated pessimist' },
  { label: 'Rumi', value: 'Rumi' },
  { label: 'a TikToker', value: 'an exaggerated and narcissistic TikTok Influencer with a zillion followers' },
  { label: 'an Astrologist', value: 'an exaggerated astrologist' },
];

export const inStyleOfDropdown: SelectField = {
  name: FieldName.styleOf,
  label: 'In style of',
  type: FormType.SELECT,
  values: inStyleOfOptions,
};

export const formOptions: Form[] = [
  {
    name: PromptType.WeddingToastSpeech,
    displayText: 'Wedding Toast Speech',
    fields: [
      {
        name: FieldName.givenBy,
        label: 'Given By',
        type: FormType.INPUT,
        placeholders: ['the maid of honor', 'a parent', 'an old friend', 'a sibling'],
      },
      {
        name: FieldName.story,
        label: 'Highlighting a story of when',
        type: FormType.INPUT,
        placeholders: [
          'the time they first met',
          'the couple went camping and forgot the tent',
          'they went to a concert and got separated',
        ],
      },
      inStyleOfDropdown,
    ],
  },
  {
    name: PromptType.LoveStoryForWeddingWebsite,
    displayText: 'Love Story for Wedding Website',
    fields: [
      {
        name: FieldName.meetingPlace,
        label: 'We first met in',
        type: FormType.INPUT,
        placeholders: ['a bar in Brooklyn', 'college', 'at a Carly Rae Jepson concert', '2020'],
      },
      {
        name: FieldName.whenStory,
        label: 'When',
        type: FormType.INPUT,
        placeholders: [
          'they asked me for directions',
          'they were dating my friend',
          'they asked me my name twice',
          'they accidentally spilled orange juice all over me',
        ],
      },
      inStyleOfDropdown,
    ],
  },
  {
    name: PromptType.RegistryGiftSuggestions,
    displayText: 'Registry Gift Suggestions',
    fields: [
      {
        name: FieldName.emphasisOn,
        label: 'With an emphasis on',
        type: FormType.INPUT,
        placeholders: ['kitchen', 'items for starting a new home', 'tabletop', 'camping', 'bed and bath'],
      },
    ],
  },
  {
    name: PromptType.WeddingHashtagIdeas,
    displayText: 'Wedding Hashtag Ideas',
    fields: [
      {
        name: FieldName.names,
        label: 'For',
        type: FormType.INPUT,
        placeholders: [
          'Noah and Allie',
          'Quincy and Monica',
          'Héloïse and Marianne',
          'Tony and Maria',
          'Baby and Johnny',
          'Ennis and Jack',
        ],
      },
      {
        name: FieldName.location,
        label: 'At',
        type: FormType.INPUT,
        placeholders: ['Aruba', 'Jamaica', 'Bermuda', 'Bahamas', 'Key Largo', 'Montigo', 'Cocomo'],
      },
      inStyleOfDropdown,
    ],
  },
  {
    name: PromptType.WeddingVows,
    displayText: 'Wedding Vows',
    fields: [
      {
        name: FieldName.sharedValues,
        label: 'Our shared values',
        type: FormType.INPUT,
        placeholders: ['never put pineapple on pizza', 'honesty always', 'long walks on the beach'],
      },
      {
        name: FieldName.loveMost,
        label: 'What you love most about your partner',
        type: FormType.INPUT,
        placeholders: [
          'the way you always make me laugh',
          'how easily I can be myself around you',
          'how accepting you are of everything about me',
        ],
      },
      inStyleOfDropdown,
    ],
  },
  {
    name: PromptType.ThankYouNote,
    displayText: 'Thank You Note',
    fields: [
      {
        name: FieldName.toPerson,
        label: 'To',
        type: FormType.INPUT,
        placeholders: ['my mother', 'my best friend George', 'my Aunt Melody'],
      },
      {
        name: FieldName.forInput,
        label: 'For',
        type: FormType.INPUT,
        placeholders: ['attending our wedding', 'the fabulous stand mixer', 'always being there for me', 'the thoughtful speech'],
      },
      inStyleOfDropdown,
    ],
  },
  {
    name: PromptType.PoliteDeclineToAnInvitation,
    displayText: 'Polite Decline to an Invitation',
    fields: [
      {
        name: FieldName.emphasisOn,
        label: 'With an emphasis on',
        type: FormType.INPUT,
        placeholders: [
          'your regret for having a conflict',
          'best wishes for their next chapter',
          'how you will never forget the first time you saw them together',
        ],
      },
      inStyleOfDropdown,
    ],
  },
];
